import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';

class LoginEndpoint extends BaseEndpoint {
  constructor(config) {
    super('api/v1/login', config);
  }

  login(username, password, returnUrl) {
    return super.create({ username, password, returnUrl });
  }

  info(returnUrl) {
    const url = super.appendUrl('/info');
    return super.httpGET({ url, query: { returnUrl } });
  }

  register(user) {
    const url = super.appendUrl('/register');
    return super.httpPOST({ url, body: user });
  }

  twoFactorLogin(twoFactorType, userId, validationToken, token, returnUrl) {
    const url = super.appendUrl('/two-factor');
    return super.httpPOST({
      url,
      body: {
        twoFactorType,
        userId,
        validationToken,
        token,
        returnUrl,
      },
    });
  }

  getErrorMessage(errorId) {
    const url = super.appendUrl('/error');
    return super.httpGET({ url, query: { errorId } });
  }
}

export class LoginClient extends BaseSDK {
  #login_endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.#login_endpoint = new LoginEndpoint(this.config);
  }

  login(username, password, returnUrl) {
    return this.#login_endpoint.login(username, password, returnUrl);
  }

  twoFactorLogin(twoFactorType, userId, validationToken, token, returnUrl) {
    return this.#login_endpoint.twoFactorLogin(
      twoFactorType,
      userId,
      validationToken,
      token,
      returnUrl,
    );
  }

  info(returnUrl) {
    return this.#login_endpoint.info(returnUrl);
  }

  register(user) {
    return this.#login_endpoint.register(user);
  }

  getErrorMessage(errorId) {
    return this.#login_endpoint.getErrorMessage(errorId);
  }
}
